import React, { Component } from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table } from 'reactstrap';
import Switch from 'react-switch';
import classnames from 'classnames';
import PaymentModal from './PaymentModal';
import Loader from '../../components/Loader';

class ConsumerMyLoans extends Component {
  state = {
    activeTab: 1,
    autopay: false,
    checked: true,
    latePayments: 0,
    loading: true,
    modal: false,
    pastDue: false,
    scheduledModal: false
  }

  componentDidMount() {
    let url = this.props.location.search;

    if (url === '?pastdue') {
      this.setState({
        pastDue: true,
        latePayments: 2
      });
    }

    if (url === '?autopay') {
      this.setState({ autopay: true });
    }

    // Show Loader for 5 seconds
    setTimeout(() => {
      this.setState(prevState => ({
        loading: false,
      }));
    }, 5000);

    this.setTab('1');
  }

  handleCheck = (checked) => {
    this.setState({ checked });
  }

  handleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleScheduledModal = () => {
    this.setState(prevState => ({
      scheduledModal: !prevState.scheduledModal,
    }));
  }

  setTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  render() {
    const { activeTab, autopay, checked, loading, modal, pastDue, scheduledModal } = this.state;

    return (
      <div className="page-myloans pb-3">
        <Container fluid>
          <Row className="mb-3 align-items-center">
            <Col className="text-center text-md-left">
              <h3 className="mb-0">Loan Details</h3>
              <small><strong>Loan Nickname</strong> – 1234567</small>
            </Col>
            <Col xs={12} md="auto" className="text-right justify-content-end ml-md-3 mt-3 mt-md-0">
              <FormGroup className="dropdown-toggle mb-0 input-inline">
                <Input type="select" name="select" id="loanSelection" defaultValue="loan1">
                  <option value="">My Loans</option>
                  <option value="loan1">Loan ID – 1234567</option>
                  <option value="loan2">Loan ID – 2098773</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6} lg={4}>

              <Card inverse color="primary">
                <CardBody className="text-center">
                  <Row>
                    <Col className="pr-0">
                      <Card className="pt-2 pb-2" style={{ height : '110px' }}>
                        { loading ?
                          <Loader className="light height-100" />
                          :
                          <div>
                            <h6>Next Payment</h6>
                            <h3 className="">$300.<small>00</small></h3>
                            <h6 className="mb-0"><span>Due by 1/28/20</span></h6>
                          </div>
                        }
                      </Card>
                    </Col>
                    <Col>
                      <Card className={`pt-2 pb-2 ${ pastDue ? 'bg-white' : '' }`} style={{ height : '110px' }}>
                        { loading ?
                          <Loader className="light height-100" />
                          :
                          <div>
                            <h6 className={ pastDue ? 'text-danger' : '' }>Past Due</h6>
                            <h3 className={ pastDue ? 'text-danger' : '' }>
                              { pastDue ? '$205.00' : '$0' }
                            </h3>
                            <h6 className={`mb-0 ${ pastDue ? 'text-danger' : '' }`}>
                              <span>{ pastDue ? 'Due Now' : 'Up to date' }</span>
                            </h6>
                          </div>
                        }
                      </Card>
                    </Col>
                  </Row>
                  { autopay ?
                    <Button color="light" outline className="w-100 mb-1" onClick={this.handleModal2}>
                      <img src="/icons/autopay.svg" alt="" className="mr-1" />
                      Manage Autopay
                    </Button>
                    :
                    <Button color="light" outline className="w-100 mb-1" onClick={this.handleModal3}>
                      <img src="/icons/autopay.svg" alt="" className="mr-1" />
                      Set Up Autopay
                    </Button>
                  }
                  <Button color="light" className="w-100" onClick={this.handleModal1}>
                    <img src="/icons/payment.svg" alt="" className="mr-1" />
                    Make A Payment
                  </Button>
                  <Row className="mt-3">
                    <Col className="text-left">
                      <strong>Paperless Billing</strong>
                    </Col>
                    <Col className="text-right">
                      <small className="mr-1"><strong>{ checked ? 'ON' : 'OFF' }</strong></small>
                      <Switch
                        onChange={this.handleCheck}
                        checked={this.state.checked}
                        className="toggle-switch float-right"
                        onColor="#04BC6C"
                        offColor="#3989E3"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardHeader>Payment Methods</CardHeader>
                <ListGroup>
                  <ListGroupItem className="position: relative">
                    <p className="mb-0"><strong>Chase Bank</strong> ending 1234</p>
                    <small>Checking</small>
                    <Button color="link" className="btn-icon position-absolute" style={{ top: 23, right: 50 }}>
                      <img src="/icons/edit.svg" alt="Edit" />
                    </Button>
                    <Button color="link" className="btn-icon position-absolute" style={{ top: 23, right: 13 }}>
                      <img src="/icons/trash.svg" alt="Delete" />
                    </Button>
                  </ListGroupItem>
                  <ListGroupItem className="position: relative">
                    <p className="mb-0"><strong>Wells Fargo Bank</strong> ending 5543</p>
                    <small>Checking &nbsp;<Badge color="primary">PRIMARY</Badge></small>
                    <Button color="link" className="btn-icon position-absolute" style={{ top: 23, right: 50 }}>
                      <img src="/icons/edit.svg" alt="Edit" />
                    </Button>
                    <Button color="link" className="btn-icon position-absolute" style={{ top: 23, right: 13 }}>
                      <img src="/icons/trash.svg" alt="Delete" />
                    </Button>
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/" className="d-flex">
                    <img src="/icons/add-primary.svg" alt="Add" className="mr-1" />
                    <strong>Add Payment Method</strong>
                  </ListGroupItem>
                </ListGroup>
              </Card>

              <Card>
                <CardHeader>Loan Info</CardHeader>
                <Table className="mb-0" size="sm" responsive striped borderless>
                  <tbody>
                    <tr>
                      <th scope="row">Principal Amount</th>
                      <td className="text-right">$6,480.00</td>
                    </tr>
                    <tr>
                      <th scope="row">Contract Date</th>
                      <td className="text-right">08/23/2019</td>
                    </tr>
                    <tr>
                      <th scope="row">Loan Term</th>
                      <td className="text-right">36 Months</td>
                    </tr>
                    <tr>
                      <th scope="row">Interest Rate</th>
                      <td className="text-right">15.74%</td>
                    </tr>
                    <tr>
                      <th scope="row">Monthly Payment Amount</th>
                      <td className="text-right">$505.00</td>
                    </tr>
                    <tr>
                      <th scope="row">Final Payment Date</th>
                      <td className="text-right">01/22/2020</td>
                    </tr>
                  </tbody>
                </Table>
              </Card>

            </Col>
            <Col md={6} lg={8}>

              <Card>

                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => { this.setTab('1'); }}>
                        Transaction<span> History</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => { this.setTab('2'); }}>
                        Payment<span> History</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => { this.setTab('3'); }}>
                        Scheduled<span> Payments</span>
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeTab}>

                  {/* Transaction History Tab */}
                  <TabPane tabId="1">
                    { loading ?
                      <Loader className="height-2" />
                      :
                      <Table className="mb-0" size="sm" responsive striped borderless>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Principal</th>
                            <th>Interest</th>
                            <th>Fees</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">09/01/2019</th>
                            <td>Payment Received</td>
                            <td>$295.00</td>
                            <td>$200.00</td>
                            <td>$5.00</td>
                            <td><strong>$505.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/16/2019</th>
                            <td>Late Fee</td>
                            <td>$0</td>
                            <td>$0</td>
                            <td>$5.00</td>
                            <td><strong>$5.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/01/2019</th>
                            <td>Payment Received</td>
                            <td>$0</td>
                            <td>$100.00</td>
                            <td>$0</td>
                            <td><strong>$100.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/19/2019</th>
                            <td>Partial Refund</td>
                            <td>($150.00)</td>
                            <td>($150.00)</td>
                            <td>$0</td>
                            <td><strong>($300.00)</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/01/2019</th>
                            <td>Payment Received</td>
                            <td>$150.00</td>
                            <td>$150.00</td>
                            <td>$0</td>
                            <td><strong>$300.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">09/01/2019</th>
                            <td>Payment Received</td>
                            <td>$295.00</td>
                            <td>$200.00</td>
                            <td>$5.00</td>
                            <td><strong>$505.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/16/2019</th>
                            <td>Late Fee</td>
                            <td>$0</td>
                            <td>$0</td>
                            <td>$5.00</td>
                            <td><strong>$5.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/01/2019</th>
                            <td>Payment Received</td>
                            <td>$0</td>
                            <td>$100.00</td>
                            <td>$0</td>
                            <td><strong>$100.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/19/2019</th>
                            <td>Partial Refund</td>
                            <td>($150.00)</td>
                            <td>($150.00)</td>
                            <td>$0</td>
                            <td><strong>($300.00)</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/01/2019</th>
                            <td>Payment Received</td>
                            <td>$150.00</td>
                            <td>$150.00</td>
                            <td>$0</td>
                            <td><strong>$300.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">09/01/2019</th>
                            <td>Payment Received</td>
                            <td>$295.00</td>
                            <td>$200.00</td>
                            <td>$5.00</td>
                            <td><strong>$505.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/16/2019</th>
                            <td>Late Fee</td>
                            <td>$0</td>
                            <td>$0</td>
                            <td>$5.00</td>
                            <td><strong>$5.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/01/2019</th>
                            <td>Payment Received</td>
                            <td>$0</td>
                            <td>$100.00</td>
                            <td>$0</td>
                            <td><strong>$100.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/19/2019</th>
                            <td>Partial Refund</td>
                            <td>($150.00)</td>
                            <td>($150.00)</td>
                            <td>$0</td>
                            <td><strong>($300.00)</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/01/2019</th>
                            <td>Payment Received</td>
                            <td>$150.00</td>
                            <td>$150.00</td>
                            <td>$0</td>
                            <td><strong>$300.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">09/01/2019</th>
                            <td>Payment Received</td>
                            <td>$295.00</td>
                            <td>$200.00</td>
                            <td>$5.00</td>
                            <td><strong>$505.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/16/2019</th>
                            <td>Late Fee</td>
                            <td>$0</td>
                            <td>$0</td>
                            <td>$5.00</td>
                            <td><strong>$5.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">08/01/2019</th>
                            <td>Payment Received</td>
                            <td>$0</td>
                            <td>$100.00</td>
                            <td>$0</td>
                            <td><strong>$100.00</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/19/2019</th>
                            <td>Partial Refund</td>
                            <td>($150.00)</td>
                            <td>($150.00)</td>
                            <td>$0</td>
                            <td><strong>($300.00)</strong></td>
                          </tr>
                          <tr>
                            <th scope="row">07/01/2019</th>
                            <td>Payment Received</td>
                            <td>$150.00</td>
                            <td>$150.00</td>
                            <td>$0</td>
                            <td><strong>$300.00</strong></td>
                          </tr>
                        </tbody>
                      </Table>
                    }
                  </TabPane>

                  {/* Payment History Tab */}
                  <TabPane tabId="2">
                    <Table className="mb-0" size="sm" responsive striped borderless>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Description</th>
                          <th>Status</th>
                          <th className="text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">02/01/2020</th>
                          <td>Payment Received</td>
                          <td>Processing</td>
                          <td className="text-right"><strong>$505.00</strong></td>
                        </tr>
                        <tr>
                          <th scope="row">01/01/2020</th>
                          <td>Payment Received</td>
                          <td>Completed</td>
                          <td className="text-right"><strong>$505.00</strong></td>
                        </tr>
                        <tr>
                          <th scope="row">12/01/2019</th>
                          <td>Payment Received</td>
                          <td>Completed</td>
                          <td className="text-right"><strong>$505.00</strong></td>
                        </tr>
                        <tr>
                          <th scope="row">11/01/2019</th>
                          <td>Payment Received</td>
                          <td>Completed</td>
                          <td className="text-right"><strong>$505.00</strong></td>
                        </tr>
                        <tr>
                          <th scope="row">10/01/2019</th>
                          <td>Payment Received</td>
                          <td>Completed</td>
                          <td className="text-right"><strong>$505.00</strong></td>
                        </tr>
                      </tbody>
                    </Table>
                  </TabPane>

                  {/* Scheduled Payments Tab */}
                  <TabPane tabId="3">
                    <Table className="mb-0" size="sm" responsive striped borderless>
                      <thead>
                        <tr>
                          <th>Next Payment Date</th>
                          <th>Payments Remaining</th>
                          <th>Frequency</th>
                          <th>Amount</th>
                          <th>Payment Method</th>
                          <th> </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">02/01/2020</th>
                          <td>21</td>
                          <td>Monthly</td>
                          <td>$505.00</td>
                          <td><strong>Wells Fargo Bank</strong> ending 4545</td>
                          <td>
                            <Button
                              onClick={this.handleScheduledModal}
                              color="link p-0 position-relative"
                              style={{ top: '-3px' }}>
                                <img src="/icons/trash.svg" alt="Cancel" />
                            </Button>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">01/01/2020</th>
                          <td>22</td>
                          <td>Monthly</td>
                          <td>$505.00</td>
                          <td><strong>Wells Fargo Bank</strong> ending 4545</td>
                          <td>
                            <Button
                              onClick={this.handleScheduledModal}
                              color="link p-0 position-relative"
                              style={{ top: '-3px' }}>
                                <img src="/icons/trash.svg" alt="Cancel" />
                            </Button>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">12/01/2019</th>
                          <td>23</td>
                          <td>Monthly</td>
                          <td>$505.00</td>
                          <td><strong>Wells Fargo Bank</strong> ending 4545</td>
                          <td>
                            <Button
                              onClick={this.handleScheduledModal}
                              color="link p-0 position-relative"
                              style={{ top: '-3px' }}>
                                <img src="/icons/trash.svg" alt="Cancel" />
                            </Button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </TabPane>

                </TabContent>

              </Card>

            </Col>
          </Row>

        </Container>

        <PaymentModal isOpen={modal} toggle={this.handleModal} />

        <Modal isOpen={scheduledModal} toggle={this.handleScheduledModal} size="md">
          <ModalHeader toggle={this.handleScheduledModal}>Turn Off Autopay</ModalHeader>
          <ModalBody className="text-center">
            <h3 className="mb-2">Turn off AutoPay to cancel<br/> future payments</h3>
            <p>If you turn off AutoPay, all future payments will be canceled.</p>
            <h4 className="mb-3">Are you sure to turn off AutoPay?</h4>
            <Button onClick={this.handleScheduledModal} color="danger" className="w-100 mb-1">Turn Off Autopay</Button>
            <Button onClick={this.handleScheduledModal} className="w-100">Go back</Button>
          </ModalBody>
        </Modal>

      </div>
    );
  }
}

export default ConsumerMyLoans;
